import React from 'react';
import { Chip } from '@mui/material';

export default function BrandHeroEyebrow({ label }) {
  return (
    <Chip
      label={label}
      sx={{
        height: 'auto',
        py: 1.25,
        fontWeight: 800,
        fontSize: '0.7rem',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: 'common.white',
        bgcolor: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.28)',
        boxShadow: '0 0 40px rgba(241, 196, 0, 0.12), inset 0 1px 0 rgba(255,255,255,0.15)',
        borderRadius: '999px',
        mb: 2,
        '& .MuiChip-label': { px: 2.25, py: 0.25 },
      }}
    />
  );
}
